import { useEvent } from "../changelog-item-context";

import ApprovalContent from "./ApprovalContent";

import UserAttribution from "@/components/UserAttribution";
import { ActionType } from "@/queries/folder-entities/types";

const EventContent = () => {
  const event = useEvent();

  // Show approval UI for label operations (MOVE_LABEL, DELETE_LABEL)
  const isLabelOperation =
    event.action_type === ActionType.MOVE_LABEL || event.action_type === ActionType.DELETE_LABEL;

  // Show approval UI if:
  // 1. It's a label operation AND not yet approved (pending approval)
  // 2. It's a label operation AND has been approved (show approval status)
  // 3. It's a label operation AND has been denied (approved_by exists but approved is false)
  const showApprovalUI = isLabelOperation && (!event.approved || event.approved_by);

  if (showApprovalUI) {
    return <ApprovalContent isApproved={event.approved} onApprove={() => undefined} />;
  }

  return <UserAttribution email={event.user?.email} />;
};

export default EventContent;
